import { render, staticRenderFns } from "./validate.vue?vue&type=template&id=89b16242&"
import script from "./validate.vue?vue&type=script&lang=js&"
export * from "./validate.vue?vue&type=script&lang=js&"
import style0 from "./validate.vue?vue&type=style&index=0&id=89b16242&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports